import StyledButton from 'components/Elements/StyledButton'
import { useTranslation } from 'react-i18next'
import { OverviewContainer } from './style'

const Overview = ({ onClickNext }) => {
  const { t } = useTranslation()
  return (
    <OverviewContainer>
      <div className="overview-items">
        <div className="overview-item">
          <div className="material-icons-outlined icon">flag</div>
          <p>{t('started_steps_overview_process')}</p>
        </div>
        <div className="overview-item">
          <div className="material-icons-outlined icon">redeem</div>
          <p>{t('started_steps_overview_other_author')}</p>
        </div>
      </div>

      <StyledButton
        type="submit"
        className="btn-blue mt-3 next-page"
        title="Continue to add your information"
        onClick={onClickNext}
      />
    </OverviewContainer>
  )
}

export default Overview
